import { useGT } from 'gt-react';
import { Badge } from '@/components/ui/badge';

/**
 * The module tags a company carries, wherever it is shown — the companies list
 * and the header of one of its pricelists read the same component so the two
 * can't drift apart in wording or in what counts as tagged.
 *
 * Renders nothing when a company has no tags, so it is safe to drop into a
 * layout unconditionally.
 */
export function CompanyTags({
  shipAndDebitEnabled,
}: {
  shipAndDebitEnabled: boolean;
}) {
  const gt = useGT();
  if (!shipAndDebitEnabled) return null;

  return (
    <Badge variant="secondary">
      {gt('Ship & Debit', {
        context: 'tag marking a company with the ship and debit module',
      })}
    </Badge>
  );
}
